import { render, staticRenderFns } from "./cross-move.vue?vue&type=template&id=067a5d5b&functional=true"
import script from "./cross-move.vue?vue&type=script&lang=js"
export * from "./cross-move.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports